/** Список заголовков */
export const HEADERS = {
  IMAGE_VERSION: 'Image-Version',
  LOCATION: 'X-Location-Route',
  RETRY_AFTER: 'Retry-After'
};
//# sourceMappingURL=headers.js.map